import { all, call, put } from 'redux-saga/effects';
import request from '../../../lib/request';
import { parseFormErrors } from '../../../utils/parseFormErrors';
import { uploadProfilePictureWithPresignedURL } from '../../upload';

export const TEACHER_PROFILE_REQUEST =
  'teacher/TEACHER_PROFILE_REQUEST';
export const TEACHER_PROFILE_SUCCESS =
  'teacher/TEACHER_PROFILE_SUCCESS';
export const TEACHER_PROFILE_FAILURE =
  'teacher/TEACHER_PROFILE_FAILURE';

export const EDIT_TEACHER_REQUEST =
  'teacher/EDIT_TEACHER_REQUEST';
export const EDIT_TEACHER_SUCCESS =
  'teacher/EDIT_TEACHER_SUCCESS';
export const EDIT_TEACHER_FAILURE =
  'teacher/EDIT_TEACHER_FAILURE';

// Get Teacher profile by Id

export const handleTeacherProfileRequest = (payload) => ({
  type: TEACHER_PROFILE_REQUEST,
  payload
});

export const handleTeacherProfileSuccess = (payload) => ({
  type: TEACHER_PROFILE_SUCCESS,
  payload
});

export const handleTeacherProfileFailure = (payload) => ({
  type: TEACHER_PROFILE_FAILURE,
  payload
});

export const handleEditTeacherProfileRequest = (payload) => ({
  type: EDIT_TEACHER_REQUEST,
  payload
});

export const handleEditTeacherProfileSuccess = (payload) => ({
  type: EDIT_TEACHER_SUCCESS,
  payload
});

export const handleEditTeacherProfileFailure = (payload) => ({
  type: EDIT_TEACHER_FAILURE,
  payload
});

export function * onHandleTeacherProfileRequest ({ payload: teacherId }) {
  console.log('#onHandleTeacherProfileRequest, studentId: ', teacherId);
  try {
    console.log('#onHandleTeacherProfileRequest, try block');

    console.log(`/teachers/${teacherId}`);
    const response = yield call(
      request.get,
    `/teacher/${teacherId}`
    );

    console.log('REPSONSE', response);

    console.log('#onHandleTeacherProfileRequest, response: ', response);
    const { teacher } = response.data;

    console.log('#onHandleStudentProfileRequest, teacher: ', teacher);

    yield all([
      put(
        handleTeacherProfileSuccess(teacher)
      )
    ]);
  } catch (err) {
    console.error('Error, #onHandleTeacherProfileRquest, err: ', err);
    yield put(handleTeacherProfileFailure(err.message));
  }
}

export function * onHandleEditTeacherProfileRequest ({ payload }) {
  console.log('#onHandleEditTeacherProfileRequest, payload: ', payload);

  try {
    console.log('#onHandleEditTeacherProfileRequest, try block');

    // if avatar exists and is a type of file
    if (payload.avatar && payload.avatar.uid) {
      console.log('#onHandleEditTeacherProfileRequest, calling uploadProfilePicture');
      const uploadedProfilePicture = yield uploadProfilePictureWithPresignedURL(payload.avatar);

      console.log('#onHandleEditStudentProfileRequest, updating Student Pfp');
      // set student's uploaded profilePicture attributes
      payload.avatar = uploadedProfilePicture;
    }

    const response = yield call(
      request.put,
      `/teacher/${payload.id}`,
      payload
    );

    console.log('#onHandleEditTeacherProfileRequest, response: ', response);

    const { teacher } = response.data;

    console.log('#onHandleEditTeacherProfileRequest, student: ', teacher);

    yield all([put(handleEditTeacherProfileSuccess(teacher))]);
    return { success: true };
  } catch (err) {
    console.error('Error, #onHandleEditTeacherProfileRequest, err: ', err);
    const { message } = err;
    yield put(
      handleEditTeacherProfileFailure({ message, ...parseFormErrors(err) })
    );
  }
}

const INITIAL_STATE = {
  isLoading: false,
  data: [],
  error: null,
  emailExists: false
};

export default function teachers (state = INITIAL_STATE, action) {
  switch (action.type) {
    case TEACHER_PROFILE_REQUEST:
    case EDIT_TEACHER_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null
      };

    case TEACHER_PROFILE_SUCCESS:
    case EDIT_TEACHER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        profile: action.payload,
        error: null
      };

    case TEACHER_PROFILE_FAILURE:
    case EDIT_TEACHER_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };

    default:
      return state;
  }
}
